import { AxiosResponse } from "axios";
import api, { ApiResponse } from "./api";

const handleError = async (response: ApiResponse<any>) => {
  if (response.ok()) {
    return response;
  } else {
    let error = response.getError?.() as any;
    error = !!error ? (typeof error === 'string' ? error : error['message']) : "Something went wrong";
    throw new Error(error);
  }
}

export const apiQueryAdapter = {
  query: async<T>(
    url: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'GETDOC',
    otherArgs: {
      params?: Record<string, any>;
      body?: Record<string, any>;
      responseType?: any;
    } = {}
  ) => {
    const { params, body, responseType } = otherArgs;
    let response;

    const options = { params, responseType };

    switch (method) {
      case 'GET':
        response = handleError(await api.get(url, { params }));
        break;
      case 'POST':
        response = handleError(await api.post(url, body, { params }));
        break;
      case 'PUT':
        response = handleError(await api.put(url, body, { params }));
        break;
      case 'DELETE':
        response = handleError(await api.delete(url, { params, data: body }));
        break;
      case 'GETDOC':
        response = handleError(await api.get(url, options));
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
    return response as unknown as AxiosResponse<T>;
  },
};
